import { render, staticRenderFns } from "./ColumnPicker.vue?vue&type=template&id=04b9e24c&"
import script from "./ColumnPicker.vue?vue&type=script&lang=js&"
export * from "./ColumnPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports